import { IAlertList } from '../types/IAlert';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetUserAlertListParams {
}

export interface IGetUserAlertListResult extends IAlertList {
}

export class GetUserAlertListRequest extends Request<IGetUserAlertListParams, IGetUserAlertListResult> {
  constructor(params: IGetUserAlertListParams = {}) {
    super('getUserAlertList', params);
  }
}
